import { useEffect, useState } from "react";
import { getRoles } from "../../services/adminService";

export default function RolesList() {
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        fetchRoles();
    }, []);

    const fetchRoles = async () => {
        try {
            const res = await getRoles();
            setRoles(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const toggleStatus = (id) => {
        setRoles((prevRoles) =>
            prevRoles.map((role) =>
                role.id === id
                    ? { ...role, status: role.status === 1 ? 0 : 1 }
                    : role
            )
        );

        // Later connect API here
        // updateRoleStatus(id)
    };

    return (
        <div className="max-w-6xl mx-auto p-4">
            <h2 className="text-2xl font-bold mb-6">Roles List</h2>

            {/* Large screen table */}
            <div className="hidden md:block bg-white shadow rounded-lg overflow-x-auto">
                <table className="w-full text-left">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="px-6 py-3 font-medium text-gray-700">Sl NO</th>
                            <th className="px-6 py-3 font-medium text-gray-700">Role ID</th>
                            <th className="px-6 py-3 font-medium text-gray-700">Role Name</th>
                            <th className="px-6 py-3 font-medium text-gray-700">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {roles.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="px-6 py-4 text-center text-gray-500">
                                    No roles found
                                </td>
                            </tr>
                        ) : (
                            roles.map((role, index) => (
                                <tr key={role.id} className="border-b hover:bg-gray-50">
                                    <td className="px-6 py-4">{index + 1}</td>
                                    <td className="px-6 py-4">{role.id}</td>
                                    <td className="px-6 py-4">{role.name}</td>
                                    <td className="px-6 py-4">
                                        <button
                                            onClick={() => toggleStatus(role.id)}
                                            className={`px-3 py-1 rounded text-white ${
                                                role.status === 1
                                                    ? "bg-green-500"
                                                    : "bg-red-500"
                                            }`}
                                        >
                                            {role.status === 1 ? "Enabled" : "Disabled"}
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Small screen card layout */}
            <div className="md:hidden space-y-4">
                {roles.length === 0 ? (
                    <p className="text-center text-gray-500">No roles found</p>
                ) : (
                    roles.map((role, index) => (
                        <div
                            key={role.id}
                            className="bg-white p-4 rounded-lg shadow"
                        >
                            <div className="grid grid-cols-2 gap-2 mb-3">
                                <div>
                                    <p className="text-gray-500 text-sm">Sl No</p>
                                    <p className="font-semibold">{index + 1}</p>
                                </div>
                                <div>
                                    <p className="text-gray-500 text-sm">ID</p>
                                    <p className="font-semibold">{role.id}</p>
                                </div>
                                <div>
                                    <p className="text-gray-500 text-sm">Role</p>
                                    <p className="font-semibold">{role.name}</p>
                                </div>
                            </div>

                            <button
                                onClick={() => toggleStatus(role.id)}
                                className={`px-3 py-1 rounded text-white ${
                                    role.status === 1
                                        ? "bg-green-500"
                                        : "bg-red-500"
                                }`}
                            >
                                {role.status === 1 ? "Enabled" : "Disabled"}
                            </button>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}